__turbopack_context__.v({
  "root": "HomePageContainer-module-scss-module___hQ2aq__root",
});
